<template>
    <v-container class="mt-10 pb-12 dashboard-container"
        style="min-width: 1200px; max-width: 1600px; padding-left: 24px; padding-right: 24px;">
        <!-- Header Section -->
        <div class="mb-6">
            <div class="d-flex align-center justify-space-between mb-4">
                <div>
                    <h1 class="text-h4 font-weight-bold mb-2">Task Approval</h1>
                    <p class="text-subtitle-1 grey--text mb-0">Manage your personal and assigned tasks</p>
                </div>
                <v-btn color="primary" outlined :loading="refreshing" @click="refreshData" class="text-none">
                    <v-icon left>mdi-refresh</v-icon>
                    Refresh
                </v-btn>
            </div>
        </div>

        <!-- Access Denied State: shown when API confirms user is not a manager -->
        <v-row v-if="!isUnapprovedTasksLoading && isManagerForApproval() === false">
            <v-col cols="12">
                <v-card elevation="0" outlined class="text-center pa-12">
                    <v-icon size="80" color="grey lighten-1">mdi-lock-outline</v-icon>
                    <div class="text-h5 mt-6 mb-3">Access Restricted</div>
                    <div class="text-body-1 grey--text">You don't have access to this page because you're not a manager.</div>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-else>
            <v-col cols="12">
                <!-- Personal Statistics Section -->
                <!-- <v-card elevation="0" outlined class="mb-4 position-relative">
                    <v-overlay :value="initialLoading" absolute>
                        <v-progress-circular indeterminate size="50" color="primary" />
                        <div class="mt-2 text-center">Loading statistics...</div>
                    </v-overlay>
                    <v-card-title class="py-2">
                        <v-icon color="primary" size="20" class="mr-2">mdi-chart-box</v-icon>
                        <span class="text-subtitle-2 font-weight-bold">My Statistics</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-3">
                        <v-row dense>
                            <v-col>
                                <v-card elevation="0" outlined class="pa-2 text-center stats-card">
                                    <v-icon color="blue" size="20" class="mb-1">mdi-format-list-bulleted</v-icon>
                                    <div class="text-h6 font-weight-bold mb-0">{{ userStats.todo_tasks }}</div>
                                    <div class="text-caption text--secondary">Todo</div>
                                </v-card>
                            </v-col>
                            <v-col>
                                <v-card elevation="0" outlined class="pa-2 text-center stats-card">
                                    <v-icon color="orange" size="20" class="mb-1">mdi-progress-clock</v-icon>
                                    <div class="text-h6 font-weight-bold mb-0">{{ userStats.in_progress_tasks }}</div>
                                    <div class="text-caption text--secondary">In Progress</div>
                                </v-card>
                            </v-col>
                            <v-col>
                                <v-card elevation="0" outlined class="pa-2 text-center stats-card">
                                    <v-icon color="error" size="20" class="mb-1">mdi-alert-circle</v-icon>
                                    <div class="text-h6 font-weight-bold mb-0">{{ overdueTasksCount }}</div>
                                    <div class="text-caption text--secondary">Overdue</div>
                                </v-card>
                            </v-col>
                            <v-col>
                                <v-card elevation="0" outlined class="pa-2 text-center stats-card">
                                    <v-icon color="teal" size="20" class="mb-1">mdi-repeat</v-icon>
                                    <div class="text-h6 font-weight-bold mb-0">{{ userStats.recurring_tasks }}</div>
                                    <div class="text-caption text--secondary">Recurring</div>
                                </v-card>
                            </v-col>
                            <v-col>
                                <v-card elevation="0" outlined class="pa-2 text-center stats-card">
                                    <v-icon color="purple" size="20" class="mb-1">mdi-eye-check</v-icon>
                                    <div class="text-h6 font-weight-bold mb-0">{{ userStats.in_review_tasks }}</div>
                                    <div class="text-caption text--secondary">In Review</div>
                                </v-card>
                            </v-col>
                            <v-col>
                                <v-card elevation="0" outlined class="pa-2 text-center stats-card">
                                    <v-icon color="success" size="20" class="mb-1">mdi-check-circle</v-icon>
                                    <div class="text-h6 font-weight-bold mb-0">{{ userStats.completed_tasks }}</div>
                                    <div class="text-caption text--secondary">Completed</div>
                                </v-card>
                            </v-col>
                            <v-col>
                                <v-card elevation="0" outlined class="pa-2 text-center stats-card">
                                    <v-icon color="red-darken-1" size="20" class="mb-1">mdi-block-helper</v-icon>
                                    <div class="text-h6 font-weight-bold mb-0">{{ userStats.blocked_tasks }}</div>
                                    <div class="text-caption text--secondary">Blocked</div>
                                </v-card>
                            </v-col>
                            <v-col>
                                <v-card elevation="0" outlined class="pa-2 text-center stats-card">
                                    <v-icon color="grey" size="20" class="mb-1">mdi-cancel</v-icon>
                                    <div class="text-h6 font-weight-bold mb-0">{{ userStats.cancelled_tasks }}</div>
                                    <div class="text-caption text--secondary">Cancelled</div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-divider inset />
                 -->
                <v-card elevation="0">
                    <v-card-text class="pb-0">
                        <div class="d-flex align-center justify-end mb-4">
                            <div class="d-flex align-start gap-3">
                                <!-- Admin User Selector -->
                                 <!--  <v-autocomplete v-model="selectedViewingUser" :items="users()" item-text="name"
                                    item-value="id" label="View tasks for user"
                                    persistent-hint prepend-inner-icon="mdi-account-search" clearable dense outlined
                                    style="max-width: 280px;"
                                    data-tour="user-selector"
                                    :disabled="isPersonalTasksLoading || isAssignedTasksLoading"
                                    :loading="isPersonalTasksLoading || isAssignedTasksLoading"
                                    @change="onUserSelectionChange"></v-autocomplete> -->

                                <!-- Bulk Selection Info -->
                                <v-chip v-if="selected_tasks.length > 0" color="primary" outlined>
                                    {{ selected_tasks.length }} task{{ selected_tasks.length == 1 ? '' : 's' }} selected
                                    <v-btn @click="openDeleteBulkTasksDialog()" color="error" icon small class="ml-2"
                                        :disabled="isUnapprovedTasksLoading">
                                        <v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                </v-chip>

                                <!-- Action Buttons -->
                                <v-btn @click="openNewTaskDialog('self')" color="success" depressed class="text-none"
                                    data-tour="create-task-btn"
                                    :disabled="isUnapprovedTasksLoading"
                                    :loading="isUnapprovedTasksLoading">
                                    <v-icon left>mdi-plus</v-icon>
                                    Create Task
                                </v-btn>
                                <v-btn @click="openNewTaskDialog('assign')" color="primary" depressed class="text-none"
                                    data-tour="assign-task-btn"
                                    :disabled="isUnapprovedTasksLoading"
                                    :loading="isUnapprovedTasksLoading">
                                    <v-icon left>mdi-account-plus</v-icon>
                                    Assign Task
                                </v-btn>
                            </div>
                        </div>

                        <!-- Task Type Tabs (only shown in Tasks view) -->
                       <!--  <v-tabs v-model="activeTab" color="primary" grow class="mb-4"
                            :disabled="isPersonalTasksLoading && isAssignedTasksLoading">
                            <v-tab data-tour="personal-tasks-tab">
                                <v-icon left>mdi-account</v-icon>
                                My Task List
                            </v-tab>
                            <v-tab data-tour="assigned-tasks-tab">
                                <v-icon left>mdi-account-group</v-icon>
                                Tasks Assigned To Others
                            </v-tab>
                        </v-tabs>
                         -->
                    </v-card-text>

                    <v-card-text>
                        <!-- Task List View -->
                        <v-tabs-items v-model="activeTab">
                            <!-- My Task List Tab -->
                            <v-tab-item>
                                <!-- Task Type Selector and Filters -->
                                 <!--  <div class="task-controls mt-4 mb-4">
                                    <v-row>
                                        <v-col>
                                            <v-autocomplete v-model="personalStatusFilters" :items="statusFilterOptions"
                                                item-text="name" item-value="id" label="Status" dense outlined multiple
                                                chips style="min-width: 180px;" :disabled="isPersonalTasksLoading"
                                                :loading="isPersonalTasksLoading">
                                                <template v-slot:prepend-inner>
                                                    <v-icon color="primary" size="16">
                                                        mdi-format-list-checks
                                                    </v-icon>
                                                </template>
                                                <template v-slot:selection="{ item, index }">
                                                    <v-chip v-if="index < 2" small close
                                                        @click:close="personalStatusFilters.splice(personalStatusFilters.indexOf(item.id), 1)">
                                                        {{ item.name }}
                                                    </v-chip>
                                                    <span v-if="index === 2" class="text-grey text-caption">
                                                        (+{{ personalStatusFilters.length - 2 }} others)
                                                    </span>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col>
                                            <v-text-field v-model="personalFilters.search" label="Search tasks..."
                                                prepend-inner-icon="mdi-magnify" dense outlined clearable
                                                style="max-width: 300px;" :disabled="isPersonalTasksLoading" />
                                        </v-col>
                                        <v-col>
                                            <v-autocomplete v-model="personalFilters.company"
                                                :items="companyFilterOptions" item-text="name" item-value="id"
                                                label="Company" dense outlined clearable style="min-width: 150px;"
                                                :disabled="isPersonalTasksLoading" />
                                        </v-col>
                                        <v-col>
                                            <v-autocomplete v-model="personalFilters.priority"
                                                :items="priorityFilterOptions" item-text="name" item-value="id"
                                                label="Priority" dense outlined clearable style="min-width: 130px;"
                                                :disabled="isPersonalTasksLoading" />
                                        </v-col>
                                        <v-col>
                                            <v-select v-model="personalFilters.dueDate" :items="dueDateFilters"
                                                item-text="name" item-value="value" label="Due Date" dense outlined
                                                clearable style="min-width: 150px;" :disabled="isPersonalTasksLoading">
                                                <template v-slot:prepend-inner>
                                                    <v-icon color="primary" size="16">
                                                        mdi-calendar
                                                    </v-icon>
                                                </template>
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                </div> -->

                                <!-- Loading state -->
                                <div v-if="isUnapprovedTasksLoading" class="text-center pa-8">
                                    <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                                    <div class="mt-4 text-subtitle-1 grey--text">Loading tasks...</div>
                                </div>

                                <!-- Approval Status Tabs: Pending vs Rejected/Cancelled -->
                                <v-card v-else elevation="0" outlined>
                                    <v-tabs v-model="approvalStatusTab" color="primary">
                                        <v-tab>
                                            <v-icon left small>mdi-clock-outline</v-icon>
                                            Pending Approval
                                            <v-chip small color="warning" class="ml-2">{{ filteredUnapprovedTasks.length }}</v-chip>
                                        </v-tab>
                                        <v-tab>
                                            <v-icon left small>mdi-close-circle-outline</v-icon>
                                            Rejected / Cancelled
                                            <v-chip small color="error" class="ml-2">{{ filteredRejectedTasks.length }}</v-chip>
                                        </v-tab>
                                    </v-tabs>
                                    <v-divider></v-divider>

                                    <v-tabs-items v-model="approvalStatusTab">
                                        <!-- Tab 0: Pending Approval -->
                                        <v-tab-item>
                                            <div v-if="rolesList.length > 0">
                                                <v-tabs v-model="activeRoleTab" color="warning" grow>
                                                    <v-tab v-for="role in rolesList" :key="role.id">
                                                        <span class="font-weight-medium">{{ role.name }}</span>
                                                        <v-chip small color="warning" class="ml-2">{{ role.count }}</v-chip>
                                                    </v-tab>
                                                </v-tabs>
                                                <v-tabs-items v-model="activeRoleTab">
                                                    <v-tab-item v-for="role in rolesList" :key="role.id">
                                                        <UnifiedTreeViewDashboard
                                                            taskType="approval"
                                                            :tasks="role.tasks"
                                                            :users="getUsersByRole()"
                                                            :companies="companies()"
                                                            @create-task="(type) => openNewTaskDialog(type || 'approval')"
                                                            @getTasks="handleTaskRefresh"
                                                            @updateTaskData="updateTaskData"
                                                            @optimisticUpdate="handleOptimisticUpdate"
                                                        />
                                                    </v-tab-item>
                                                </v-tabs-items>
                                            </div>
                                            <div v-else class="text-center pa-8">
                                                <v-icon size="64" color="grey lighten-1">mdi-clipboard-text-outline</v-icon>
                                                <div class="text-h6 mt-4 grey--text">No tasks pending approval</div>
                                                <div class="text-caption grey--text">All tasks have been reviewed</div>
                                            </div>
                                        </v-tab-item>

                                        <!-- Tab 1: Rejected / Cancelled -->
                                        <v-tab-item>
                                            <div v-if="rejectedRolesList.length > 0">
                                                <v-tabs v-model="activeRejectedRoleTab" color="error" grow>
                                                    <v-tab v-for="role in rejectedRolesList" :key="role.id">
                                                        <span class="font-weight-medium">{{ role.name }}</span>
                                                        <v-chip small color="error" class="ml-2">{{ role.count }}</v-chip>
                                                    </v-tab>
                                                </v-tabs>
                                                <v-tabs-items v-model="activeRejectedRoleTab">
                                                    <v-tab-item v-for="role in rejectedRolesList" :key="role.id">
                                                        <UnifiedTreeViewDashboard
                                                            taskType="approval"
                                                            :tasks="role.tasks"
                                                            :users="getUsersByRole()"
                                                            :companies="companies()"
                                                            @getTasks="handleTaskRefresh"
                                                            @updateTaskData="updateTaskData"
                                                            @optimisticUpdate="handleOptimisticUpdate"
                                                        />
                                                    </v-tab-item>
                                                </v-tabs-items>
                                            </div>
                                            <div v-else class="text-center pa-8">
                                                <v-icon size="64" color="grey lighten-1">mdi-check-circle-outline</v-icon>
                                                <div class="text-h6 mt-4 grey--text">No rejected or cancelled tasks</div>
                                                <div class="text-caption grey--text">No tasks have been rejected or cancelled</div>
                                            </div>
                                        </v-tab-item>
                                    </v-tabs-items>
                                </v-card>
                            </v-tab-item>

                            <!-- Tasks Assigned To Others Tab -->
                            <!-- <v-tab-item> -->
                                <!-- Task Type Selector and Filters -->
                                  <!-- 
                                <div class="task-controls mt-4 mb-4">
                                    <v-row>
                                        <v-col>
                                            <v-autocomplete v-model="assignedStatusFilters" :items="statusFilterOptions"
                                                item-text="name" item-value="id" label="Status" dense outlined multiple
                                                chips deletable-chips style="min-width: 180px;"
                                                :disabled="isAssignedTasksLoading" :loading="isAssignedTasksLoading">
                                                <template v-slot:prepend-inner>
                                                    <v-icon color="primary" size="16">
                                                        mdi-format-list-checks
                                                    </v-icon>
                                                </template>
                                                <template v-slot:selection="{ item, index }">
                                                    <v-chip v-if="index < 2" small close
                                                        @click:close="assignedStatusFilters.splice(assignedStatusFilters.indexOf(item.id), 1)">
                                                        {{ item.name }}
                                                    </v-chip>
                                                    <span v-if="index === 2" class="text-grey text-caption">
                                                        (+{{ assignedStatusFilters.length - 2 }} others)
                                                    </span>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col>
                                            <v-text-field v-model="assignedFilters.search" label="Search tasks..."
                                                prepend-inner-icon="mdi-magnify" dense outlined clearable
                                                style="max-width: 300px;" :disabled="isAssignedTasksLoading" />
                                        </v-col>
                                        <v-col>
                                            <v-autocomplete v-model="assignedFilters.company"
                                                :items="companyFilterOptions" item-text="name" item-value="id"
                                                label="Company" dense outlined clearable style="min-width: 150px;"
                                                :disabled="isAssignedTasksLoading" />
                                        </v-col>
                                        <v-col>
                                            <v-autocomplete v-model="assignedFilters.priority"
                                                :items="priorityFilterOptions" item-text="name" item-value="id"
                                                label="Priority" dense outlined clearable style="min-width: 130px;"
                                                :disabled="isAssignedTasksLoading" />
                                        </v-col>
                                        <v-col>
                                            <v-select v-model="assignedFilters.dueDate" :items="dueDateFilters"
                                                item-text="name" item-value="value" label="Due Date" dense outlined
                                                clearable style="min-width: 150px;" :disabled="isAssignedTasksLoading">
                                                <template v-slot:prepend-inner>
                                                    <v-icon color="primary" size="16">
                                                        mdi-calendar
                                                    </v-icon>
                                                </template>
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                </div>

                                <transition name="fade" mode="out-in">
                                    <div v-if="isAssignedTasksLoading" key="loading-assigned" class="text-center pa-8">
                                        <v-progress-circular indeterminate color="primary"
                                            size="48"></v-progress-circular>
                                        <div class="mt-4 text-subtitle-1 grey--text">Loading assigned tasks...</div>
                                    </div>
                                    <div v-else-if="filteredAssignedTasksForDisplay.length === 0" key="empty-assigned"
                                        class="text-center pa-8">
                                        <v-icon size="64" color="grey lighten-1">mdi-clipboard-text-outline</v-icon>
                                        <div class="text-h6 mt-4 grey--text">No assigned tasks found</div>
                                        <div class="text-caption grey--text">Assign tasks to others to see them here
                                        </div>
                                    </div>
                                    <UnifiedTreeViewDashboard v-else key="assigned-tasks" taskType="assigned"
                                        :tasks="filteredAssignedTasksForDisplay" :users="users()"
                                        :companies="companies()" @create-task="openNewTaskDialog"
                                        @getTasks="handleTaskRefresh" @updateTaskData="updateTaskData"
                                        @optimisticUpdate="handleOptimisticUpdate" />
                                </transition>
                            </v-tab-item> -->
                        </v-tabs-items>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="delete_task_dialog" persistent max-width="500">
            <v-card>
                <v-card-title>Are you sure you want to delete this task?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeDeleteTaskDialog()" text>Cancel</v-btn>
                    <v-btn @click="deleteTask()" color="error">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- New Enhanced Task Creation Dialog -->
        <TaskCreationDialog v-model="new_task_dialog" :users="users()" :companies="companies()"
            :task-type="new_task_type" :is-approval-mode="true" @tasks-created="onTasksCreated" @close="closeNewTaskDialog" />
        <v-dialog v-model="delete_bulk_tasks_dialog" persistent max-width="500">
            <v-card v-if="selected_tasks">
                <v-card-title>Are you sure you want to delete these tasks?</v-card-title>
                <v-card-text>
                    <div v-for="(task, index) in selected_tasks" :key="index">
                        {{ task.name }}
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeDeleteBulkTasksDialog()" text>Cancel</v-btn>
                    <v-btn @click="deleteBulkTasks()" color="error">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="show_filters_dialog" persistent max-width="500">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-select v-model="selected_priorities" :items="[{ name: 'None', id: null }, ...get_priorities]"
                        multiple item-text="name" item-value="id" label="Filter by priority"
                        @change="handleTaskRefresh"></v-select>
                    <v-select v-model="selected_statuses" :items="[{ name: 'None', id: null }, ...get_statuses]"
                        multiple item-text="name" item-value="id" label="Filter by status"
                        @change="handleTaskRefresh"></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeShowFiltersDialog()" text>Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import UnifiedTreeViewDashboard from '../modules/UnifiedTreeViewDashboard.vue'
import TaskCreationDialog from '../modules/TaskCreationDialog.vue'

export default {
    name: 'TaskAssignmentComponent',
    inject: [
        'users', 'updateUser', 'addUser', 'removeUser', 'refreshUsers',
        'unapprovedTasks', 'refreshUnapprovedTasks',
        'rejectedTasks',
        'isManagerForApproval',
        'updateTaskInArrays',
        'optimisticUpdateTask', 'optimisticDeleteTask', 'optimisticCreateTask',
        'priorities', 'statuses', 'tags', 'meetingStatuses',
        'refreshPriorities', 'refreshStatuses', 'refreshTags', 'refreshMeetingStatuses',
        'companies', 'refreshCompanies',
        'allManagers',
        'overviewTasks', 'refreshOverviewTasks',
        'roleTasksMap', 'refreshRoleTasksMap',
        // Loading state providers
        'isLoadingUsers', 'isLoadingTasks', 'tasksLoaded',
    ],
    components: {
        UnifiedTreeViewDashboard,
        TaskCreationDialog,
    },
    data: () => ({
        loading: false,
        initialLoading: true,
        refreshing: false,
        api_url: null,
        is_company_selected: false,
        activeTab: 0,
        selectedViewingUser: null, // For admin to view other users' tasks
        dueDateFilters: [
            { name: 'All', value: null },
            { name: 'Overdue', value: 'overdue' },
            { name: 'Due Today', value: 'today' },
            { name: 'Due This Week', value: 'week' },
            { name: 'Due This Month', value: 'month' },
        ],
        selected_tasks: [],
        selected_assignee: {
            id: null,
            name: null,
            access: [],
        },
        due_date_menu: [],
        due_date_menu_assigned: [],
        new_task_dialog: false,
        new_task_type: 'assign',
        task_headers: [
            { text: "", width: "1%", sortable: false },
            { text: "Task Name", value: "name", width: "41%", sortable: false },
            { text: "Due Date", value: "due_date", width: "15%", sortable: false },
            {
                text: "Allocated Time",
                value: "allocated_time",
                width: "12%",
                sortable: false,
            },
            { text: "Priority", value: "priority_id", width: "14%", sortable: false },
            { text: "Status", value: "status_id", width: "17%", sortable: false },
            { text: "", width: "1%", sortable: false },
        ],
        header_personal: [
            { text: "Task", value: "name", width: "10%" },
            { text: "Due Date", value: "due_date", width: "5%" },
            { text: "Date created", value: "created", width: "5%" },
            { text: "Company", value: "company", width: "5%" },
            { text: "Assignees", value: "assignee", width: "5%" },
            { text: "Status", value: "status", width: "5%" },
            { text: "Priority", value: "priority", width: "5%", sortable: true },
            { text: "", value: "view", width: "5%" },
        ],
        header_assigned: [
            { text: "Task", value: "name", width: "10%" },
            { text: "Due Date", value: "due_date", width: "5%" },
            { text: "Date created", value: "created", width: "5%" },
            { text: "Company", value: "company", width: "5%" },
            { text: "Assignees", value: "assignee", width: "5%" },
            { text: "Status", value: "status", width: "5%" },
            { text: "Tag", value: "tags", width: "5%" },
            { text: "Priority", value: "priority", width: "5%", sortable: true },
            { text: "", value: "view", width: "5%" },
        ],
        delete_task_dialog: false,
        task_to_delete: null,
        task_details_dialog: false,
        original_selected_task: null,
        edit_bulk_tasks_dialog: false,
        delete_bulk_tasks_dialog: false,
        can_close_task_details_dialog: false,
        navigation: {
            width: 600,
            borderSize: 5,
        },
        show_filters_dialog: false,
        create_quick_task: false,
        selected_assign_filter: "",
        chooseUserModel: false,
        searchUser: null,
        showUnapprovedTasks: true, // Show unapproved tasks section by default
        activeRoleTab: 0, // Track active role tab
        activeRejectedRoleTab: 0, // Track active role tab for rejected section
        approvalStatusTab: 0, // 0 = Pending Approval, 1 = Rejected/Cancelled
    }),
    async created() {
        this.api_url = process.env.VUE_APP_API_URL
    },
    async mounted() {
        await Promise.all([
            typeof this.refreshUnapprovedTasks === 'function' ? this.refreshUnapprovedTasks() : Promise.resolve(),
            typeof this.refreshOverviewTasks === 'function' ? this.refreshOverviewTasks() : Promise.resolve(),
        ]).catch(() => {});

        document.title = "DG Tasks - Task Approval";
        this.initialLoading = false;
    },
    computed: {
        ...mapGetters({
            get_user: "auth/get_user",
            get_selected_company: "companies/get_selected_company",
            get_priorities: "tasks/get_priorities",
            get_statuses: "tasks/get_statuses",
            get_selected_priorities: "tasks/get_selected_priorities",
            get_selected_statuses: "tasks/get_selected_statuses",
            selectedUserGetters: "tasks/getUserId",
            getterTag: "tasks/getTags",
            userStats: "auth/get_user_stats",
            get_meeting_statuses: "meetings/get_meeting_statuses",
            get_preferences: "auth/get_preferences",
            get_roles: "auth/get_roles",
        }),
        // Loading state computed properties
        isUnapprovedTasksLoading() {
            // Only check whether the unapproved tasks array itself is ready.
            // Do NOT gate on isLoadingTasks / tasksLoaded — those track the
            // main personal/assigned task load, which is unrelated and can
            // keep this spinner alive long after unapproved tasks are available.
            if (!this.unapprovedTasks) return true
            const tasks = this.unapprovedTasks()
            return tasks === undefined || tasks === null
        },
        // Computed wrappers for injected reference data
        prioritiesData() {
            return this.priorities ? this.priorities() : [];
        },
        statusesData() {
            return this.statuses ? this.statuses() : [];
        },
        tagsData() {
            return this.tags ? this.tags() : [];
        },
        delayCompletedTasksLoad() {
            return this.$store.getters["auth/get_preferences"]?.delayCompletedTasksLoad ?? false;
        },
        selected_priorities: {
            get() {
                return this.get_selected_priorities;
            },
            set(new_priorities) {
                this.$store.dispatch("tasks/set_selected_priorities", new_priorities);
            },
        },
        selected_statuses: {
            get() {
                return this.get_selected_statuses;
            },
            set(new_statuses) {
                this.$store.dispatch("tasks/set_selected_statuses", new_statuses);
            },
        },
        prioritiesSelect() {
            return [{ name: "None", id: null }, ...(this.prioritiesData || [])];
        },
        statusesSelect() {
            return [{ name: "None", id: null }, ...(this.statusesData || [])];
        },
        tagsSelect() {
            return [{ name: "None", id: null }, ...(this.tagsData || [])];
        },
        filteredUsers() {
            if (this.searchUser !== null) {
                return this.users().filter((q) =>
                    q.name.toLowerCase().includes(this.searchUser.toLowerCase())
                );
            }
            return this.users();
        },
        // Filter options
        statusFilterOptions() {
            return this.statusesData || [];
        },
        companyFilterOptions() {
            const companies = this.companies() || [];
            return [{ name: 'All Companies', id: null }, ...companies];
        },
        priorityFilterOptions() {
            return [{ name: 'All Priorities', id: null }, ...(this.prioritiesData || [])];
        },
        // Role IDs that the current user is a member of
        managedRoleIds() {
            const managers = this.allManagers ? this.allManagers() : [];
            return managers
                .filter(m => m.user_id === this.get_user?.id)
                .map(m => m.user_role_id);
        },
        // Unapproved tasks (status_id = 8) filtered by selected company and managed roles
        filteredUnapprovedTasks() {
            const userRoleMembers = this.get_user?.role_members || [];
            const isSuperAdmin = this.get_user?.role_id === 1 || userRoleMembers.some(m => m.user_role_id === 1);

            // Backend now scopes correctly for all user types:
            // - Superadmin gets all status_id=8 tasks (no role filter)
            // - Managers get only tasks in their managed roles
            let unapproved = this.unapprovedTasks ? this.unapprovedTasks() || [] : [];

            if (!isSuperAdmin) {
                // Extra client-side scope: filter to roles this manager manages
                if (this.managedRoleIds.length > 0) {
                    unapproved = unapproved.filter(task =>
                        this.managedRoleIds.includes(task.role_id) || task.role_id == null
                    );
                }
            }

            // Filter by selected company if one is selected
            if (this.get_selected_company && this.get_selected_company.id) {
                unapproved = unapproved.filter(task => task.company_id === this.get_selected_company.id);
            }

            return unapproved;
        },
        // Group unapproved tasks by role_id
        tasksByRole() {
            const grouped = {};
            const tasks = this.filteredUnapprovedTasks;
            
            tasks.forEach(task => {
                const roleId = task.role_id || 'unassigned';
                if (!grouped[roleId]) {
                    grouped[roleId] = [];
                }
                grouped[roleId].push(task);
            });
            
            return grouped;
        },
        // Get role names for display
        rolesList() {
            const roles = [];
            const allRoles = this.get_roles || [];
            
            Object.keys(this.tasksByRole).forEach(roleId => {
                if (roleId === 'unassigned') {
                    roles.push({
                        id: 'unassigned',
                        name: 'Unassigned Role',
                        tasks: this.tasksByRole[roleId],
                        count: this.tasksByRole[roleId].length
                    });
                } else {
                    const role = allRoles.find(r => r.id === parseInt(roleId));
                    roles.push({
                        id: roleId,
                        name: role ? role.name : `Role ${roleId}`,
                        tasks: this.tasksByRole[roleId],
                        count: this.tasksByRole[roleId].length
                    });
                }
            });
            
            return roles;
        },

        // Rejected / Cancelled tasks (status_id = 9) scoped the same way
        filteredRejectedTasks() {
            const userRoleMembers = this.get_user?.role_members || [];
            const isSuperAdmin = this.get_user?.role_id === 1 || userRoleMembers.some(m => m.user_role_id === 1);
            let tasks = this.rejectedTasks ? this.rejectedTasks() || [] : [];
            if (!isSuperAdmin && this.managedRoleIds.length > 0) {
                tasks = tasks.filter(t => this.managedRoleIds.includes(t.role_id) || t.role_id == null);
            }
            if (this.get_selected_company && this.get_selected_company.id) {
                tasks = tasks.filter(t => t.company_id === this.get_selected_company.id);
            }
            return tasks;
        },
        rejectedByRole() {
            const grouped = {};
            this.filteredRejectedTasks.forEach(task => {
                const roleId = task.role_id || 'unassigned';
                if (!grouped[roleId]) grouped[roleId] = [];
                grouped[roleId].push(task);
            });
            return grouped;
        },
        rejectedRolesList() {
            const roles = [];
            const allRoles = this.get_roles || [];
            Object.keys(this.rejectedByRole).forEach(roleId => {
                if (roleId === 'unassigned') {
                    roles.push({ id: 'unassigned', name: 'Unassigned Role', tasks: this.rejectedByRole[roleId], count: this.rejectedByRole[roleId].length });
                } else {
                    const role = allRoles.find(r => r.id === parseInt(roleId));
                    roles.push({ id: roleId, name: role ? role.name : `Role ${roleId}`, tasks: this.rejectedByRole[roleId], count: this.rejectedByRole[roleId].length });
                }
            });
            return roles;
        },
    },
    methods: {
        getUsersByRole() {
            return this.users() || [];
        },
        async refreshData() {
            this.refreshing = true;
            try {
                const refreshCalls = [
                    this.refreshUsers(),
                    this.refreshStatuses(),
                    this.refreshPriorities(),
                    this.refreshCompanies(),
                ];
                if (this.get_user?.role_id === 1) {
                    refreshCalls.push(this.refreshOverviewTasks());
                } else {
                    refreshCalls.push(this.refreshUnapprovedTasks());
                }
                await Promise.all(refreshCalls);
                this.$toast.success('Data refreshed successfully');
            } catch (error) {
                console.error('Error refreshing data:', error);
                this.$toast.error('Failed to refresh data');
            } finally {
                this.refreshing = false;
            }
        },
        // Central method to handle task refresh requests from child components
        handleTaskRefresh() {
            if (this.get_user?.role_id === 1) {
                if (typeof this.refreshOverviewTasks === 'function') {
                    this.refreshOverviewTasks();
                }
            } else if (typeof this.refreshUnapprovedTasks === 'function') {
                this.refreshUnapprovedTasks();
            } else {
                console.warn('[Dashboard] refreshUnapprovedTasks method not available from injection');
            }
        },
        openNewTaskDialog(type = 'assign') {
            this.new_task_type = type
            this.new_task_dialog = true
        },
        closeNewTaskDialog() {
            this.new_task_dialog = false
        },
        onTasksCreated() {
            // Refresh unapproved tasks after new task creation
            setTimeout(() => {
                if (this.get_user?.role_id === 1) {
                    if (typeof this.refreshOverviewTasks === 'function') {
                        this.refreshOverviewTasks();
                    }
                } else if (typeof this.refreshUnapprovedTasks === 'function') {
                    this.refreshUnapprovedTasks();
                }
            }, 1000);
        },
        updateTaskData({ taskId, updatedData }) {
            // Use injected method to update task in provider arrays
            this.updateTaskInArrays(taskId, updatedData);
        },
        async updateTask(item) {
            if (this.optimisticUpdateTask) {
                // Use optimistic update pattern from DefaultLayout
                const taskUpdates = {
                    h_id: item.h_id,
                    company_id: item.company_id,
                    assignee_id: item.assignee_id,
                    project_id: item.project_id,
                    name: item.name,
                    status_id: item.status_id,
                    description: item.description,
                    priority_id: item.priority_id,
                    due_date: item.due_date,
                    allocated_time: item.allocated_time,
                    tags: item.tags,
                };

                console.log('Optimistically updating task with data:', taskUpdates);

                try {
                    await this.optimisticUpdateTask(
                        item.id,
                        taskUpdates,
                        async () => {
                            const response = await this.$axios.post(`api/tasks/update_task/${item.id}`, taskUpdates);
                            if (!response.data.response) {
                                throw new Error(response.data.message);
                            }
                            return response.data;
                        }
                    );
                } catch (error) {
                    this.$toast.error(error.message || 'Failed to update task');
                }
            } else {
                // Fallback to original implementation
                let payload = {
                    h_id: item.h_id,
                    company_id: item.company_id,
                    assignee_id: item.assignee_id,
                    project_id: item.project_id,
                    name: item.name,
                    status_id: item.status_id,
                    description: item.description,
                    priority_id: item.priority_id,
                    due_date: item.due_date,
                    allocated_time: item.allocated_time,
                    tags: item.tags,
                }
                await this.$axios.post(`api/tasks/update_task/${item.id}`, payload)
                    .then(({ data }) => {
                        if (data.response) {
                            this.$toast.success(data.message)
                            // Task already updated in local arrays, no need to refresh
                        } else {
                            this.$toast.error(data.message)
                        }
                    });
            }
        },
        selectTask(item) {
            let index = this.selected_tasks.findIndex((x) => x.id == item.id)
            if (index === -1) {
                this.selected_tasks.push(item)
            } else {
                this.selected_tasks.splice(index, 1)
            }
        },
        openEditBulkTasksDialog() {
            this.edit_bulk_tasks_dialog = true
        },
        closeEditBulkTasksDialog() {
            this.edit_bulk_tasks_dialog = false
        },
        openDeleteBulkTasksDialog() {
            this.delete_bulk_tasks_dialog = true
        },
        closeDeleteBulkTasksDialog() {
            this.delete_bulk_tasks_dialog = false
        },
        async deleteBulkTasks() {
            if (!this.selected_tasks || this.selected_tasks.length === 0) {
                this.$toast.error('No tasks selected');
                return;
            }

            // Store tasks for rollback
            const tasksToDelete = [...this.selected_tasks];
            const taskIds = tasksToDelete.map(task => task.id);

            // Clear selection and close dialog immediately
            this.selected_tasks = [];
            this.closeDeleteBulkTasksDialog();

            // Optimistic delete - remove from arrays immediately if possible
            if (this.optimisticDeleteTask) {
                // Use optimistic delete for each task
                const deletePromises = taskIds.map(taskId =>
                    this.optimisticDeleteTask(taskId, async () => {
                        // This will be called for each task, but we'll do bulk delete
                        return { success: true };
                    })
                );

                try {
                    // Wait for optimistic deletes to complete
                    await Promise.all(deletePromises);

                    // Now make the actual API call
                    const response = await this.$axios.post("api/tasks/delete_tasks", tasksToDelete);

                    if (response.data.response) {
                        this.$toast.success(response.data.message);
                        // Tasks already removed optimistically, no need to refresh
                    } else {
                        throw new Error(response.data.message);
                    }
                } catch (error) {
                    // The optimistic delete methods will handle rollback
                    console.error('Error deleting tasks:', error);
                    this.$toast.error(error.message || 'Failed to delete tasks');
                }
            } else {
                // Fallback to original implementation
                await this.$axios.post("api/tasks/delete_tasks", tasksToDelete)
                    .then(({ data }) => {
                        if (data.response) {
                            this.$toast.success(data.message);
                            // Tasks already handled in local arrays
                        } else {
                            this.$toast.error(data.message);
                        }
                    });
            }
        },
        openShowFiltersDialog() {
            this.show_filters_dialog = true
        },
        closeShowFiltersDialog() {
            this.show_filters_dialog = false
        },

        // Helper methods
        isTaskCompleted(task) {
            return task.status_id === 4
        },
        isTaskOverdue(task) {
            if (!task.due_date) return false;
            if (this.isTaskCompleted(task)) return false; // Completed tasks aren't overdue

            const now = new Date();
            const dueDate = new Date(task.due_date);
            return dueDate < now;
        },
        // Optimistic updates for statistics
        handleOptimisticUpdate(updateData) {
            const { type, taskData, previousData, field, newValue, previousValues } = updateData;

            switch (type) {
                case 'create':
                    this.optimisticStatsForCreate(taskData);
                    break;
                case 'update':
                    this.optimisticStatsForUpdate(taskData, previousData);
                    break;
                case 'delete':
                    this.optimisticStatsForDelete(taskData);
                    break;
                case 'bulk_update':
                    this.optimisticStatsForBulkUpdate(field, newValue, previousValues);
                    break;
            }
        },
        optimisticStatsForCreate(taskData) {
            const currentStats = { ...this.userStats };
            
            // Increment appropriate status count based on task status
            if (taskData.status_id === 1) { // Todo
                currentStats.todo_tasks = (currentStats.todo_tasks || 0) + 1;
            } else if (taskData.status_id === 2) { // In Progress
                currentStats.in_progress_tasks = (currentStats.in_progress_tasks || 0) + 1;
            } else if (taskData.status_id === 3) { // In Review
                currentStats.in_review_tasks = (currentStats.in_review_tasks || 0) + 1;
            } else if (taskData.status_id === 4) { // Completed
                currentStats.completed_tasks = (currentStats.completed_tasks || 0) + 1;
            } else if (taskData.status_id === 5) { // Cancelled
                currentStats.cancelled_tasks = (currentStats.cancelled_tasks || 0) + 1;
            } else if (taskData.status_id === 6) { // Blocked
                currentStats.blocked_tasks = (currentStats.blocked_tasks || 0) + 1;
            }

            this.$store.dispatch('auth/set_user_stats', currentStats);
        },
        optimisticStatsForUpdate(newTaskData, oldTaskData) {
            const currentStats = { ...this.userStats };

            // Handle status changes
            if (oldTaskData.status_id !== newTaskData.status_id) {
                // Remove from old status
                if (oldTaskData.status_id === 1) { // Todo
                    currentStats.todo_tasks = Math.max(0, (currentStats.todo_tasks || 0) - 1);
                } else if (oldTaskData.status_id === 2) { // In Progress
                    currentStats.in_progress_tasks = Math.max(0, (currentStats.in_progress_tasks || 0) - 1);
                } else if (oldTaskData.status_id === 3) { // In Review
                    currentStats.in_review_tasks = Math.max(0, (currentStats.in_review_tasks || 0) - 1);
                } else if (oldTaskData.status_id === 4) { // Completed
                    currentStats.completed_tasks = Math.max(0, (currentStats.completed_tasks || 0) - 1);
                } else if (oldTaskData.status_id === 5) { // Cancelled
                    currentStats.cancelled_tasks = Math.max(0, (currentStats.cancelled_tasks || 0) - 1);
                } else if (oldTaskData.status_id === 6) { // Blocked
                    currentStats.blocked_tasks = Math.max(0, (currentStats.blocked_tasks || 0) - 1);
                }

                // Add to new status
                if (newTaskData.status_id === 1) { // Todo
                    currentStats.todo_tasks = (currentStats.todo_tasks || 0) + 1;
                } else if (newTaskData.status_id === 2) { // In Progress
                    currentStats.in_progress_tasks = (currentStats.in_progress_tasks || 0) + 1;
                } else if (newTaskData.status_id === 3) { // In Review
                    currentStats.in_review_tasks = (currentStats.in_review_tasks || 0) + 1;
                } else if (newTaskData.status_id === 4) { // Completed
                    currentStats.completed_tasks = (currentStats.completed_tasks || 0) + 1;
                } else if (newTaskData.status_id === 5) { // Cancelled
                    currentStats.cancelled_tasks = (currentStats.cancelled_tasks || 0) + 1;
                } else if (newTaskData.status_id === 6) { // Blocked
                    currentStats.blocked_tasks = (currentStats.blocked_tasks || 0) + 1;
                }
            }

            this.$store.dispatch('auth/set_user_stats', currentStats);
        },
        optimisticStatsForDelete(taskData) {
            const currentStats = { ...this.userStats };
            
            // Decrement appropriate status count based on deleted task status
            if (taskData.status_id === 1) { // Todo
                currentStats.todo_tasks = Math.max(0, (currentStats.todo_tasks || 0) - 1);
            } else if (taskData.status_id === 2) { // In Progress
                currentStats.in_progress_tasks = Math.max(0, (currentStats.in_progress_tasks || 0) - 1);
            } else if (taskData.status_id === 3) { // In Review
                currentStats.in_review_tasks = Math.max(0, (currentStats.in_review_tasks || 0) - 1);
            } else if (taskData.status_id === 4) { // Completed
                currentStats.completed_tasks = Math.max(0, (currentStats.completed_tasks || 0) - 1);
            } else if (taskData.status_id === 5) { // Cancelled
                currentStats.cancelled_tasks = Math.max(0, (currentStats.cancelled_tasks || 0) - 1);
            } else if (taskData.status_id === 6) { // Blocked
                currentStats.blocked_tasks = Math.max(0, (currentStats.blocked_tasks || 0) - 1);
            }

            this.$store.dispatch('auth/set_user_stats', currentStats);
        },

        optimisticStatsForBulkUpdate(field, newValue, previousValues) {
            // For bulk updates, we process each task individually
            if (field === 'status_id') {
                const currentStats = { ...this.userStats };

                // Process each task's status change
                previousValues.forEach(({ statusId: oldStatusId }) => {
                    // Remove from old status count
                    if (oldStatusId === 2) { // In Progress
                        currentStats.in_progress_tasks = Math.max(0, (currentStats.in_progress_tasks || 0) - 1);
                    } else if (oldStatusId === 4) { // Completed
                        currentStats.completed_tasks = Math.max(0, (currentStats.completed_tasks || 0) - 1);
                    }

                    // Add to new status count
                    if (newValue === 2) { // In Progress
                        currentStats.in_progress_tasks = (currentStats.in_progress_tasks || 0) + 1;
                    } else if (newValue === 4) { // Completed
                        currentStats.completed_tasks = (currentStats.completed_tasks || 0) + 1;
                    }
                });

                this.$store.dispatch('auth/set_user_stats', currentStats);
            }
            // Priority changes don't affect stats, so we don't need to handle them here
        },

        applyCommonFilters(tasks, filters) {
            return tasks.filter(task => {
                // Status filter (primary filter - applied first)
                // If status filters are specified, only show tasks with those statuses
                if (filters.status && filters.status.length > 0) {
                    if (!filters.status.includes(task.status_id)) {
                        return false;
                    }
                }

                // Search filter (task name or description) - within selected statuses
                if (filters.search) {
                    const searchTerm = filters.search.toLowerCase();
                    const nameMatch = task.name && task.name.toLowerCase().includes(searchTerm);
                    const descMatch = task.description && task.description.toLowerCase().includes(searchTerm);
                    if (!nameMatch && !descMatch) return false;
                }

                // Company filter - within selected statuses
                if (filters.company !== null && task.company_id !== filters.company) {
                    return false;
                }

                // Priority filter - within selected statuses
                if (filters.priority !== null && task.priority_id !== filters.priority) {
                    return false;
                }

                // Due date filter - within selected statuses
                if (filters.dueDate) {
                    if (!task.due_date) return false;
                    const today = new Date();
                    today.setHours(0, 0, 0, 0); // Start of today
                    const dueDate = new Date(task.due_date);
                    dueDate.setHours(0, 0, 0, 0); // Start of due date

                    switch (filters.dueDate) {
                        case 'overdue': {
                            // Check if task is overdue (before today, not including today) and not completed/cancelled
                            const isOverdue = dueDate < today;
                            const status = this.get_statuses.find(s => s.id === task.status_id);
                            const isCompleted = status && ['completed', 'cancelled'].includes(status.name.toLowerCase());
                            if (!isOverdue || isCompleted) return false;
                            break;
                        }
                        case 'today':
                            if (dueDate.toDateString() !== today.toDateString()) return false;
                            break;
                        case 'week': {
                            const weekFromNow = new Date(today);
                            weekFromNow.setDate(today.getDate() + 7);
                            if (!(dueDate >= today && dueDate <= weekFromNow)) return false;
                            break;
                        }
                        case 'month': {
                            const monthFromNow = new Date(today);
                            monthFromNow.setMonth(today.getMonth() + 1);
                            if (!(dueDate >= today && dueDate <= monthFromNow)) return false;
                            break;
                        }
                        default:
                            // 'All' or null - show all tasks
                            break;
                    }
                }

                return true;
            });
        },
    }
}
</script>


<style lang="scss" scoped>
.custom-menu {
    background-color: white !important;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.tight-checkbox {
    padding: 0px !important;
    margin: 0px !important;
    min-height: 30px;
}

.v-checkbox {
    margin: 0px !important;
    padding: 2px 5px !important;
}

.custom-checkbox-text {
    font-size: 0.9rem;
    font-weight: 900;
    color: #333;
    text-transform: uppercase;
}

.task-view-toggle {
    padding: 16px;
    border-top: 1px solid #e0e0e0;
    background-color: #fafbfc;

    .v-btn-toggle {
        border-radius: 6px;
        overflow: hidden;

        .v-btn {
            font-weight: 500;
            text-transform: none;
            padding: 8px 16px;

            &:not(.v-btn--active) {
                background-color: white;
                color: #666;
            }

            &.v-btn--active {
                background-color: #1976d2;
                color: white;
            }

            .v-icon {
                margin-right: 4px;
            }
        }
    }
}

// Enhanced View Mode Toggle Styling
.view-mode-toggle {
    border: 2px solid #e0e0e0;

    .v-btn {
        font-size: 1rem;
        min-width: 140px;
        transition: all 0.3s ease;

        &:not(.v-btn--active) {
            background-color: #ffffff;
            color: #666666;

            &:hover {
                background-color: #f5f5f5;
            }
        }

        &.v-btn--active {
            background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
            color: white;
            box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);

            .v-icon {
                animation: pulse 0.5s ease;
            }
        }

        .v-icon {
            font-size: 22px;
        }
    }
}

@keyframes pulse {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
    }
}

.gap-3 {
    gap: 12px;
}

.stats-card {
    border-radius: 12px;
    transition: all 0.2s ease;
    min-height: 90px;
    position: relative;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
    }

    .text-xs {
        position: absolute;
        bottom: 8px;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
    }
}

.gap-2 {
    gap: 8px;
}

.text-xs {
    font-size: 0.65rem !important;
    line-height: 1.1;
}

.task-controls {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e9ecef;
}

.gap-2 {
    gap: 8px !important;
}

@media (max-width: 768px) {
    .task-controls .d-flex {
        flex-direction: column;

        >* {
            width: 100% !important;
            max-width: none !important;
            min-width: auto !important;
        }
    }
}

/* Fade transition for smoother rendering */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}
</style>
